import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from 'use-toast-mui';
import { InputAdornment, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CommonModalButton from '../../form-components/CommonModalButton';
import { setEmployeePassword } from '../../api/adminSwitch';
import { errorMessages } from '../../utils/methods';
import {
  SwitchModal,
  PasswordModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  PasswordModalBody,
  PasswordLabel,
  PasswordInput,
  PasswordModalFooter,
} from './AdminSwitchStyled';

const SetPasswordModal = ({ open, onClose, employee, token, onSuccess }) => {
  const { t } = useTranslation();
  const toast = useToast();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setPassword('');
    setConfirmPassword('');
    setShowPassword(false);
    setShowConfirmPassword(false);
    onClose();
  };

  const handleSubmit = async () => {
    if (!password.trim()) {
      toast.error('비밀번호를 입력해주세요');
      return;
    }
    if (password !== confirmPassword) {
      toast.error('비밀번호가 일치하지 않습니다');
      return;
    }
    setLoading(true);
    try {
      await setEmployeePassword(token, employee.employeeId, {
        password,
        employeeLoginYn: 'Y',
      });
      toast.success(`${employee.name}님의 비밀번호가 설정되었습니다`);
      setPassword('');
      setConfirmPassword('');
      onSuccess();
    } catch (err) {
      toast.error(errorMessages(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <SwitchModal open={open} onClose={handleClose}>
      <PasswordModalContainer>
        <ModalHeader>
          <ModalTitle>{employee?.name || ''} 비밀번호 설정</ModalTitle>
          <CloseButton onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
        </ModalHeader>
        <PasswordModalBody>
          <PasswordLabel>비밀번호</PasswordLabel>
          <PasswordInput
            type={showPassword ? 'text' : 'password'}
            autoComplete="new-password"
            size="small"
            placeholder="비밀번호를 입력해주세요"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoFocus
            sx={{ marginBottom: '16px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" size="small">
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <PasswordLabel>비밀번호 확인</PasswordLabel>
          <PasswordInput
            type={showConfirmPassword ? 'text' : 'password'}
            autoComplete="new-password"
            size="small"
            placeholder="비밀번호를 다시 입력해주세요"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') handleSubmit();
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end" size="small">
                    {showConfirmPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </PasswordModalBody>
        <PasswordModalFooter>
          <CommonModalButton variant="cancel" onClick={handleClose}>
            {t('취소')}
          </CommonModalButton>
          <CommonModalButton variant="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? '설정 중...' : '설정'}
          </CommonModalButton>
        </PasswordModalFooter>
      </PasswordModalContainer>
    </SwitchModal>
  );
};

export default SetPasswordModal;
